import { render, staticRenderFns } from "./HRProject.vue?vue&type=template&id=33c7708a&"
import script from "./HRProject.vue?vue&type=script&lang=js&"
export * from "./HRProject.vue?vue&type=script&lang=js&"
import style0 from "./HRProject.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports